"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUnitDependencies = void 0;

var _dependenciesUnitClassGenerated = require("./dependenciesUnitClass.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var createUnitDependencies = {
  UnitDependencies: _dependenciesUnitClassGenerated.UnitDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createCreateUnit: _factoriesAny.createCreateUnit
};
exports.createUnitDependencies = createUnitDependencies;